module.exports = __webpack_public_path__ + "static/media/img5.10e404ea.jpg";